<template>
  <div class="flex flex-col rounded-m bg-grey-extralight m-3">
      <div class="bg-grey-lightest rounded-t-m font-semibold p-4 text-grey-darkest">Prescribed Medicines</div>
      <div class="px-4 pt-3 pb-2">
        <div v-for="(med, index) in data.medications" :key="index">
          <div class="flex flex-col pt-1 pb-2">
            <div class="flex">
              <div class="text-sm text-grey-darkest font-semibold"><span class="capitalize">{{`${med.name}`}}</span>{{`, ${med.dose_quantity} ${med.dose_unit}`}}</div>
              <div v-if="med.duration && med.duration_unit" class="text-sm text-grey-darkest ml-4"> for <span class="font-semibold">{{med.duration}} {{med.duration_unit}}</span></div>
            </div>
            <div class="flex py-1">
              <div class="flex text-xs text-grey-dark capitalize" style="">{{med.frequency}}</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Chat/DrugPrescriptionCard.vue